<app-law-firm-search-side-form
	*ngIf="!lawFirm"
	class="w-full"
	[placeholder]="placeholder"
	[showClerk]="showClerk"
	(onSelectedLawfirm)="selectLawFirm($event)"
	(onCreateLawfirm)="createLawFirm($event)"
	(onSelectedLawyer)="selectLawyer($event)"
	[showAiIcon]="!!(fieldMappings$ | async)?.otherPartyLawFirm"
	[label]="label"
	[skeletonLoading]="skeletonLoading"
></app-law-firm-search-side-form>

<div [@openClose] *ngIf="showCreateForm" class="my-4">
	<app-create-law-firm-side-form
		(onCreate)="_onCreate($event)"
		(onCancel)="_onCancel()"
		[name]="lawFirmName"
	>
	</app-create-law-firm-side-form>
</div>

<ng-container *ngIf="lawFirm">
	<div *ngIf="!skeletonLoading; else showLoading">
		<div class="flex gap-2">
			<p>Law Firm</p>
			<app-icon
				[icon]="AI_ICON"
				[classes]="AI_CLASSES"
				*ngIf="(fieldMappings$ | async)?.otherPartyLawFirm"
				[matTooltip]="AI_TOOLTIP"
			></app-icon>
		</div>
		<app-firm-card
			[name]="lawFirm?.name"
			[address]="setAddress(lawFirm?.address)"
			[phone]="lawFirm?.phoneNumber"
			[fax]="lawFirm?.faxNumber"
			[email]="lawFirm?.email"
			member="LAWFIRM"
			memberType="Business"
			[hoverShadow]="hoverShadow"
			(dropdown)="lawFirmDropdownOptionSelect($event)"
			[testHook]="testHooks.FirmCard"
		>
		</app-firm-card>
		<div class="mt-5">
			<app-lawyer-side-form
				class="mt-2"
				[lawFirm]="lawFirm"
				(onSelectLawyer)="selectLawyer($event)"
				(onRemoveLawyer)="removeLawyer()"
				(onFocus)="_onFocus()"
				[ngClass]="{ 'mr-2': showClerk }"
			></app-lawyer-side-form>
		</div>
	</div>
</ng-container>

<ng-template #showLoading>
	<ui-skeleton-loader [type]="skeletonLoadingFirmType" />
</ng-template>
